import { render } from "./Simulateur.vue?vue&type=template&id=472f9bde&scoped=true"
import script from "./Simulateur.vue?vue&type=script&lang=js"
export * from "./Simulateur.vue?vue&type=script&lang=js"

import "./Simulateur.vue?vue&type=style&index=0&id=472f9bde&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472f9bde"]])

export default __exports__